<template>
    <div>
        <div class="card overflow-hidden p-3 m-0">
            <div
                :class="{'no-image': !hasImage}"
                class="grid-container">
                <div
                    v-if="hasImage"
                    class="grid-area-image">
                    <EventEntryImage :images="event.images" />
                </div>
                <div class="grid-area-info">
                    <EventEntryEventInfo
                        :event="event"
                        :hide-categories="hideCategories" />
                </div>
                <div class="grid-area-price">
                    <div class="price-divider" />
                    <EventEntryPriceAndOrganizerInfo :event="event" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventEntryImage from "@/components/pages/eventIFrame/EventEntry/EventEntryOverview/EventEntryImage";
import EventEntryEventInfo from "@/components/pages/eventIFrame/EventEntry/EventEntryOverview/EventEntryEventInfo";
import EventEntryPriceAndOrganizerInfo
    from "@/components/pages/eventIFrame/EventEntry/EventEntryOverview/EventEntryPriceAndOrganizerInfo";

export default {
    name: "EventEntryOverview",
    components: {EventEntryPriceAndOrganizerInfo, EventEntryEventInfo, EventEntryImage},
    props: {
        event: {
            type: Object,
            required: true
        },
        hideCategories: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasImage() {
            return !!this.event?.images?.length
        }
    }
}
</script>

<style lang="scss" scoped>

.grid-container {
    display: grid;
    gap: map-get($spacers, 4);
    grid-template-columns: 1fr;
    grid-template-rows: 100px auto auto;
    grid-template-areas:
    "image"
    "info"
    "price";

    &.no-image {
        grid-template-rows: auto auto;
        grid-template-areas:
            "info"
            "price";
    }
}

@include media-breakpoint-up(sm) {
    .grid-container {
        grid-template-columns: 2fr 1fr;
        grid-template-rows: 100px auto;
        grid-template-areas:
            "image image"
            "info price";


        &.no-image {
            grid-template-rows: auto;
            grid-template-areas:
              "info price";
        }
    }
}

@include media-breakpoint-up(md) {
    .grid-container {
        grid-template-columns: 1fr 3fr 1fr;
        grid-template-rows: auto;
        grid-template-areas:
            "image info price";

        &.no-image {
            grid-template-columns: 63fr 1fr 16fr;
            grid-template-areas:
                  "info not-existing-just-because-of-the-gap-column price";
        }
    }

}


.grid-area-image {
    grid-area: image;
    margin: map-get($spacers, -3);

    @include media-breakpoint-up(md) {
        margin-right: 0;
    }
}

.grid-area-info {
    grid-area: info;
}

.grid-area-price {
    grid-area: price;
    position: relative;
}

@include media-breakpoint-up(sm) {
    .price-divider {
        position: absolute;
        top: 0;
        bottom: 0;
        left: map-get($spacers, -4) / 2;
        border-image: linear-gradient(to bottom, $white, $border-color 30%, $border-color 70%, $white) 1 100%;
        border-left-width: 1px;
        border-left-style: solid;
    }
}


</style>
